<div>
  <app-vctp-from-filter *ngIf="years"
    [years]="years"
    [yearSelected]="yearSelected"
    (search)="searchData($event)">
  </app-vctp-from-filter>
  <mat-divider></mat-divider>
  <app-vctp-from-bar-chart
    [title]="text"
    [subtitle]="subtitle"
    [displayUnits]="displayUnits"
    [data]="data">
  </app-vctp-from-bar-chart>
</div>
